import { scaleOrdinal } from '@visx/scale';

import { COLORS_PALETTE_DEFAULT } from '../../constants';
import type { OrdinalScale } from '../types/Scale';

/**
 * Creates an ordinal color scale for automatic series coloring.
 * Ordinal scales automatically map domain values (seriesKeys) to range values (colors).
 *
 * @returns An ordinal scale that maps series keys to colors from the COLORS_PALETTE_DEFAULT palette
 */
export function createColorScale(): OrdinalScale<string, string> {
  return scaleOrdinal<string, string>({
    range: COLORS_PALETTE_DEFAULT,
    // Domain is auto-populated as series keys are used
  });
}
